import React, { useCallback, useContext, useEffect, useState } from "react";
import EmployeesContext from "./context";
import CompanyContext from "../CompanyWrapper/context";
import fetchEmployees from "../../../../../services/employees/fetchEmployees";

export default function EmployeesWrapper(props: any) {
  const [isLoading, setIsLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [employeesNotRemoved, setEmployeesNotRemoved] = useState([]);

  const { company } = useContext(CompanyContext);

  const loadEmployees = useCallback(async () => {
    if (company?.id?.length > 0) {
      setIsLoading(true);
      await fetchEmployees({
        companyId: company.id,
        callback: (e) => {
          setEmployees(e);
          setEmployeesNotRemoved(e.filter(({ state }) => state !== "removed"));
        },
      });
      setIsLoading(false);
    }
  }, [company]);

  useEffect(() => {
    loadEmployees();
  }, [loadEmployees]);

  return (
    <EmployeesContext.Provider
      value={{
        employees,
        setEmployees,
        loadEmployees,
        isLoading,
        setIsLoading,
        employeesNotRemoved,
      }}
      {...props}
    />
  );
}
